import axios from 'axios';

const appsettings = axios.get('/appsettings.json').then(response => response.data);

export default appsettings;
